import React, { useState, useEffect, useRef } from 'react';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import { Redirect, Link } from 'react-router-dom';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { setAuthData } from '../../actions/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReCAPTCHA from 'react-google-recaptcha';
import AppUnavailableAlert from '../commonComponents/AppUnavailableAlert';
import LoadingComponent from '../commonComponents/LoadingComponent';

const Login = ({ history, setAuthData, authData, type }) => {
	let workspace = type === 'login' ? 'workspace' : 'workspaceRegister';
	let OAuth = ['authorization_code','saml'];
	let reCaptchaValue = null;
	companyName = companyName ? companyName : process.env.companyName;
	console.log(process.env); // ✅ Works if built correctly 

	const [formData, setFormData] = useState({
		workspace: {
			name: 'companyName',
			label: 'Workspace',
			type: 'text',
			requiredFlag: true,
			// forgotFlag: process.env.forgotUI === 'true' ? process.env.forgotUI : false,
			// forgotURL: process.env.forgotUI === 'true' ? '/login/forgotworkspace' : null,
			loadingFlag: false,
			text_value: companyName ? companyName : null,
			disabledFlag: companyName ? true : false
		},
		password: {
			name: 'password',
			label: 'Password',
			type: 'password',
			requiredFlag: true,
			forgotFlag: process.env.forgotUI === 'true' ? process.env.forgotUI : false,
			forgotURL: process.env.forgotUI === 'true' ? '/login/forgotpassword' : null,
			forgotTabIndex: '-1',
		},
		firstName: { name: 'firstName', label: 'First Name', type: 'text', requiredFlag: true },
		lastName: { name: 'lastName', label: 'Last Name', type: 'text' },
		workspaceRegister: {
			name: 'companyName',
			label: 'Workspace',
			type: 'text',
			requiredFlag: true,
			loadingFlag: false,
		},
		website: { name: 'website', label: 'Website', type: 'text', requiredFlag: true },
		phoneNumber: { name: 'phoneNumber', label: 'Phone Number', type: 'text' },
		email: { name: 'username', label: 'Email', type: 'email', requiredFlag: true },
		passwordRegister: { name: 'password', label: 'Password', type: 'password', requiredFlag: true, loadingFlag: false},
	});
	//true if workspace already exists
	const [isValidWorkspace, setIsValidWorkspace] = useState(false);
	// response from companyName API
	const [workspaceApiResponse, setWorkspaceApiResponse] = useState({});
	const [error, setError] = useState('');
	const [tokenResponse, setTokenResponse] = useState('');

	const [isLoading, setIsLoading] = useState(false);
	const [loginCounter,setLoginCounter]=useState(null);
	const reCaptchaRef = useRef();

	useEffect(() => {
		// load icon for error
		feather.replace();
	}, [error]);

	useEffect(() => {
		// reset states when type changes
		setFormData((prevState) => ({
			...prevState,
			email: { ...prevState.email, disabled: false },
			password: { ...prevState.password, disabled: false },
			workspace: { ...prevState.workspace, errorFlag: undefined, loadingFlag: false },
			workspaceRegister: { ...prevState.workspaceRegister, errorFlag: undefined, loadingFlag: false },
		}));
		setError('');
		setTokenResponse('');
		setIsLoading(false);
		setIsValidWorkspace(false);
		setWorkspaceApiResponse({});

	}, [type]);

	useEffect(() => {
		if(parseInt(window.localStorage.getItem("LoginCounter")) >0){
			setError("Login after some time");
			document.getElementById('submit').disabled=true;
			document.getElementById('companyName_form_data').disabled=true;
			setTimeout(() => {
				document.getElementById('submit').removeAttribute('disabled');
				document.getElementById('companyName_form_data').removeAttribute('disabled');
				setError("");
				setTokenResponse('');
			},parseInt(window.localStorage.getItem("LoginCounter"))*1000);
		}
		if (companyName) {
			handleForm({ target: { name: "workspace", value: companyName } });
		}
	}, [])

	useEffect(() => {
		const validParams = localStorage.validParams ? JSON.parse(localStorage.validParams) : null;
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		if (
			(validParams !== null || urlParams.get('grant_type') == 'saml') &&
			(validParams !== undefined || urlParams.get('grant_type') == 'saml') &&
			(location.pathname != '/workspace' || urlParams.get('grant_type') == 'saml') &&
			urlParams.get('code') &&
			type === 'login'
		) {
			let companyCheck = validParams?.companyName !== null && validParams?.companyName !== undefined ? true : urlParams.get('companyName') ? true : false;
			let grantCheck = validParams?.grant_type !== null && validParams?.grant_type !== undefined ? true : urlParams.get('grant_type') ? true : false;
			if (companyCheck && grantCheck) {
				if (OAuth.indexOf(validParams?.grant_type)>-1 || OAuth.indexOf(urlParams.get('grant_type'))>-1) {
					const code = urlParams.get('code');
					const state = urlParams.get('state');
					if (code !== null && state !== null) {
						const url = '/app/oidc/token';

						const data = {
							code: code,
							state: state,
							iss: validParams?.iss,
							redirectUri: validParams?.redirectUri,
							companyName: validParams?.companyName ? validParams?.companyName : urlParams.get('companyName'),
							username: urlParams.get("email") ? urlParams.get("email") : null
						};

						const params = {
							auth: 'system',
						};
						setIsLoading(true);

						CallAPI('POST', url, data, params, 0, function (response) {
							setIsLoading(false);
							if (response.Code == '204') {
								const cookies = handleAuthResponse(response);
								localStorage.clear();
								// console.log(cookies);
								setAuthData(cookies);
								appType = appType ? appType : process.env.appType;
								if (appType && appType.toLowerCase() == 'admin') history.push('/admin');
								else history.push('/');
							} else if (response.Code == '400') {
								setError(response.Status);	
								setTokenResponse(response.Status);							
							} else if (response.Code == '401') {
								setError(response.Status);
								setTokenResponse(response.Status);							
							}
						});
					}
				}
			}
		}
	}, [type]);

	useEffect(() => {
		if(loginCounter == 0){
			document.getElementById('submit').removeAttribute('disabled');
			window.localStorage.setItem("LoginAttempts","0");
			setError('');
			setTokenResponse('');
		}else{
			if(loginCounter){
				setError(`Try after ${loginCounter} Seconds`);
			}else{
				//setError('')
			}
		}
	}, [loginCounter])

	const recaptchaHandle = (value) => {
		if (value !== null) {
			reCaptchaValue = value;
		} else reCaptchaValue = null;
	}

	const getRedirectUri = () => {
		//TODO: have to configure redirect URI for production
		const redirectUri = `${location.origin}/login/`;
		return redirectUri;
	};
    const redirectUrl=()=>{
		history.push('/login')
	}
	const handleFormApiResponse = (response) => {
		// reset loading flag, after getting response from API
		setIsLoading(false);

		if (response.data == 'error') {
			return;
		}
		setWorkspaceApiResponse(response);

		var validParams = {
			companyName: companyName ? companyName : document.getElementById("companyName_form_data").value,
			grant_type: null,
		};

		if (type == 'login') {
			setIsValidWorkspace(true);
			setError('')

			if (response.grant_type == 'authorization_code') {
				setFormData((prevState) => ({
					...prevState,
					email: { ...prevState.email, disabled: true },
					password: { ...prevState.password, disabled: true },
					workspace: { ...prevState.workspace, errorFlag: false, loadingFlag: false },
				}));
				validParams.iss = response.iss;
				const redirectUri = getRedirectUri();
				validParams.redirectUri = redirectUri;
			}else {
				// disable email and password inputs
				setFormData((prevState) => ({
					...prevState,
					email: { ...prevState.email, disabled: false },
					password: { ...prevState.password, disabled: false },
					workspace: { ...prevState.workspace, errorFlag: false, loadingFlag: false },
				}));
			}

			validParams.grant_type = response.grant_type;
		    if(response.grant_type == 'saml'){
				localStorage.clear();
				sessionStorage.clear();
			}
			window.localStorage.setItem('validParams', JSON.stringify(validParams));
		}

		// handle error
		if (response.Code && response.Code == '400') {
			let workspaceStatus = type == 'login' ? false : true;
			let err = type == 'login' ? 'Workspace does not exist' : '';

			setIsValidWorkspace(workspaceStatus);
			setError(err);

			setFormData((prevState) => ({
				...prevState,
				[workspace]: { ...prevState[workspace], errorFlag: !workspaceStatus, loadingFlag: false },
			}));
		} else if (type == 'register') {
			setIsValidWorkspace(false);
			setFormData((prevState) => ({
				...prevState,
				workspaceRegister: { ...prevState.workspaceRegister, errorFlag: true, loadingFlag: false },
			}));
			setError('Workspace already exists');
		}
	};

	const handleForm = (event) => {
		const target = event.target;

		// run only for workspace input
		var authData = localStorage['persist:root'] && JSON.parse(localStorage['persist:root'])['dataSet'] ? JSON.parse(JSON.parse(localStorage['persist:root'])['dataSet'])['authData'] : null
		if (authData && (window.location.href.includes('login') || window.location.href.includes('workspace'))) {
			alert("Previous session is already active. Please logout and login again.");
			window.location.reload()
		} else if (target.name === 'workspace' || target.name === 'companyName') {
			const companyName = target.value;
			const redirectUri = getRedirectUri();
			const url = `/app/oidc/auth?companyName=${encodeURIComponent(
				companyName.toLowerCase()
			)}&redirectUri=${encodeURIComponent(redirectUri)}`;

			const params = {
				auth: 'system',
			};

			// set loading flag, before calling API
			setFormData((prevState) => ({
				...prevState,
				[workspace]: { ...prevState[workspace], loadingFlag: true },
			}));

			/* setError(''); */

			// set loading flag, before calling API
			setIsLoading(true);
            localStorage.clear();
			sessionStorage.clear();
			CallAPI('get', url, null, params, 0, handleFormApiResponse);
		} else if (target.name === 'password' && type === "register") {
			if(target.value !== "") {
				setFormData((prevState) => ({
					...prevState,
					['passwordRegister']: { ...prevState['passwordRegister'], loadingFlag: true },
				}));
				var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
				if (strongRegex.test(target.value.trim()) === false) {
					let string = <ul className="list-group">
						<li className="list-group-item tx-bold bd-x-0 bd-y-0">Password Requirements:</li>
						<li className="list-group-item bd-x-0 bd-y-0">-Must be 8 characters or longer.</li>
						<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 lowercase alphabet.</li>
						<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 uppercase alphabet.</li>
						<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 numeric character.</li>
						<li className="list-group-item bd-x-0 bd-y-0">-Must contain at least 1 special character.</li>
					</ul>
					setError(string);
				} else {
					setError('');
				}
				setFormData((prevState) => ({
					...prevState,
					['passwordRegister']: { ...prevState['passwordRegister'], loadingFlag: false },
				}));
			} else {
				setError('');
			}
		} else if (target.name === 'username' && type === "login" && process.env.forgotUI === 'true') {
			let currentValues = JSON.parse(window.localStorage.getItem("validParams"))
			currentValues['userName'] = target.value.trim();
			window.localStorage.setItem('validParams', JSON.stringify(currentValues));
		}
	};

	const handleAuthResponse = (user_info) => {
		let cookies = {};
		cookies.username = user_info.username ? user_info.username : user_info['user-info'].preferred_username;
		cookies.expiry = user_info.expr;
		cookies.userStatus = user_info.active;
		cookies.access_token = user_info.access_token;
		cookies.refresh_token = user_info.refresh_token;
		cookies.identity = user_info.identity;
		cookies.siteId = user_info.siteId;
		cookies.userId = user_info.userId ? user_info.userId : user_info['user-info'].sub;
		cookies.firstName = user_info.firstName;
		cookies.lastName = user_info.lastName;
		cookies.companyName = user_info.companyName;
		cookies.extraInfo = user_info['user-info'].extraInfo;
		cookies.sessionId = user_info.sessionId;
		return cookies;
	};

	const isCurrentDateTimeBetween=(startDateTime, endDateTime) =>{

        var currentDateTime = new Date(); // Get the current date and time
        let startDateTimeObj = new Date(startDateTime);
        let endDateTimeObj = new Date(endDateTime)
        // Compare the current date and time with the start and end date/times
        return currentDateTime >= startDateTimeObj && currentDateTime <= endDateTimeObj;
    }
	const handleSubmit = (event) => {
		const target = event.target;
		// only submit if workspace is valid and is of password type
		if (isValidWorkspace && (error == '' || target.name == 'login') && !target.outerText.includes('SSO')) {
			// if (isValidWorkspace && workspaceApiResponse.grant_type == 'password' && type === 'login') {
			//reset error
			setError('');

			const companyName = target[0].value;
			// let fd = new FormData();
			let fd = {};

			jQuery(`form[name='${type}']`)
				.serializeArray()
				.map(function (innerData) {
					if (type == 'register' && innerData.name == 'username') {
						fd['email'] = innerData.value;
					}
					if (innerData.name === "g-recaptcha-response") {
						fd['token'] = innerData.value;
					} else {
						fd[innerData.name] = innerData.value;
					}
				});

			const url = type == 'login' ? `/app/oidc/token` : `/app/authentication/signup`;

			const params = { auth: 'system' };

			// set loading flag, before calling API
			setIsLoading(true);
			CallAPI('POST', url, fd, params, 0, function (response) {
				// reset loading flag, after getting response from API
				setIsLoading(false);
				process.env.recaptcha === "true" ? reCaptchaRef.current.reset() : null;
				// successfull login, redirect
				if (response.Code == '204') {
					if (type == 'register') {
						history.push('/login');
					} else {
						localStorage.clear();
						response.companyName = companyName;
						const cookies = handleAuthResponse(response);
						setAuthData(cookies);
						// window.localStorage.setItem('Cookies', JSON.stringify(cookies));
						window.localStorage.setItem("LoginAttempts", "0");
						appType = appType ? appType : process.env.appType;
						if (appType && appType.toLowerCase() == 'admin') history.push('/admin');
						else history.push('/');
					}
				}
				// handle error
				else if (response.Code == '400') {
					if (window.localStorage.getItem("LoginAttempts")) {
						let attempt = parseInt(window.localStorage.getItem("LoginAttempts"));
						attempt = attempt + 1;
						if (attempt > 2) {
							window.localStorage.setItem("LoginAttempts", attempt.toString());
							document.getElementById('submit').disabled = true;
							var counter = 20;
							var loginCountdown = setInterval(function () {
								counter--
								setLoginCounter(counter);
								window.localStorage.setItem("LoginCounter", counter.toString());
								if (counter === 0) {
									clearInterval(loginCountdown);
								}
							}, 1000);
						} else {
							window.localStorage.setItem("LoginAttempts", attempt.toString());
							setError('Invalid Details Provided');
						}
					} else {
						window.localStorage.setItem("LoginAttempts", "1");
						setError('Invalid Details Provided');
					}
				} else if (response.Code == '409') {
					setError('User already exists');
				}else if (response.Code == '401') {
					setError(response.Status)    //No access to the application.
				}
			});
		} else if (error != '' && target.name == 'register') {
			alert("Entered password doesn't match requirements!")
		}
		else{
			event.preventDefault();
			if (workspaceApiResponse?.authorizeURL) {
				window.location.assign(workspaceApiResponse?.authorizeURL);
			} else {
				console.error("Something went wrong!");
			}
		}
		typeof event !== 'string' ? event.preventDefault() : null;
	};

	let data = {
		workspace: formData.workspace,
	};
	let btnText = (btnText = 'Log in');
	if (OAuth.indexOf(workspaceApiResponse.grant_type)>-1 && type === 'login') {
		btnText = `Continue with ${workspaceApiResponse.buttonName}`;
	} else if (workspaceApiResponse.grant_type === 'password' && type === 'login') {
		data = {
			workspace: formData.workspace,
			email: formData.email,
			password: formData.password,
		};
	} else if (type === 'register') {
		btnText = 'Sign Up';
		data = {
			firstName: formData.firstName,
			lastName: formData.lastName,
			workspace: formData.workspaceRegister,
			website: formData.website,
			phoneNumber: formData.phoneNumber,
			email: formData.email,
			password: formData.passwordRegister,
		};
	}

	if (isLoading) {
		btnText = 'Loading';
	}

	const form = <Form label_array={data} handleForm={handleForm} formType={type} />;

	// error box
	const error_alert = (
		<div className="alert alert-outline alert-danger d-flex justify-content-center align-items-center" role="alert">
			<i data-feather="alert-circle" className="mg-r-10"></i> {error}
		</div>
	);

	const submitBtn =
		OAuth.indexOf(workspaceApiResponse.grant_type)>-1 && type === 'login' ? (
			<a href={workspaceApiResponse.authorizeURL}>
				<button
					type="button"
					id="submit"
					className={`btn btn-primary btn-block ${process.env.recaptcha === "true" ? "mg-t-10" : null}`}
					disabled={(!isValidWorkspace && error) || isLoading}
					style={{ cursor: ((!isValidWorkspace && error) || isLoading) ? 'auto' : 'pointer' }}
				>
					{btnText}
					{isLoading ? (
						<span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true" />
					) : null}
				</button>
			</a>
		) : (
				<button
					type="submit"
					id="submit"
					className={`btn btn-primary btn-block ${process.env.recaptcha === "true" ? "mg-t-10" : null}`}
					disabled={(!isValidWorkspace && error) || isLoading}
					style={{ cursor: ((!isValidWorkspace && error) || isLoading) ? 'auto' : 'pointer' }}

				>
					{btnText}
					{isLoading ? (
						<span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true" />
					) : null}
				</button>
			);

	
	let currentPageName = location.pathname.split("/")[location.pathname.split("/").length - 1]
	// redirect if authData exists
	if (authData && typeof authData == 'object' && authData.access_token && type === 'login') { //&& currentPageName !== 'workspace'
		return <Redirect to="/dataset" />;
	}
	// console.log("Env " + process.env.enableCreateWorkspace)	
	// console.log(process.env);
	let parsedMaintenance = workspaceApiResponse?.maintenance ? JSON.parse(workspaceApiResponse?.maintenance) : "";
	let isMaintenanceTrue = isCurrentDateTimeBetween(parsedMaintenance?.startTime, parsedMaintenance?.endTime)
	const inputEndTime = parsedMaintenance?.endTime ? new Date(parsedMaintenance?.endTime) : "";
	const formattedIST = inputEndTime.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
	let message = parsedMaintenance?.status == 'enable' && isMaintenanceTrue ? `Application is under maintenance till ${formattedIST}. Please try again later! ` : "You are not allowed for this Action. Please contact your IT Administrator to activate this."
	if(!companyName){
		let logoName = window.location.hostname.split('.')[0];
		logo = logoNameArray.indexOf(logoName)!=-1 ? logoName : "rockmetric";
	}else logo = companyName;
	logo = logo.replace(" ","");

	let logoIMG = logo ? `/assets/images/logos/${logo}.png` : `/assets/images/logos/rockmetric.png`;

	return (
		parsedMaintenance?.status == 'enable' && isMaintenanceTrue ?
			<AppUnavailableAlert message={message} handleClick={redirectUrl} style={false} /> : <>
				{getParameters('grant_type') == 'saml' ? "" : <><h3 className="tx-center mg-b-20">{type == 'register' ? 'Sign up' : 'Log in'}</h3>
				</>}
				{process.env.enableCreateWorkspace != 'true' && process.env.enableCreateWorkspace != true && type == "register" ? <AppUnavailableAlert message={message} handleClick={redirectUrl} style={false} /> : <>
					{getParameters('grant_type') == 'saml' && !tokenResponse ? <LoadingComponent applicationLoading={true} /> :
						getParameters('grant_type') == 'saml' && tokenResponse ? <>
							<div className='container'>
								<div className='d-flex justify-content-center'>
									<img
										src={logoIMG}
										alt="Logo"
										className="mg-b-40 mg-t-40 wd-150"
									/>
								</div>
								<div
									className={"card mg-b-20 pd-xs-x-40 pd-x-20 pd-y-30 rounded-10"}
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,0.1)',
									}}
								>
									{error ? error_alert : null}
									<form
										autoComplete="off"
										spellCheck="false"
										onSubmit={handleSubmit}
										data-parsley-validate=""
										data-parsley-trigger="change"
										noValidate=""
										id={`${type}_form_component`}
										name={type}
									>
										{form}
										{process.env.recaptcha === "true" ?
											<ReCAPTCHA
												ref={reCaptchaRef}
												style={isValidWorkspace === true || type === 'register' ? { display: 'inline-block' } : { display: 'none' }}
												sitekey={process.env.SITE_KEY}
												onChange={recaptchaHandle}
											/>
											: null}
										{submitBtn}
									</form></div></div></> : <>				{error ? error_alert : null}
							<form
								autoComplete="off"
								spellCheck="false"
								onSubmit={handleSubmit}
								data-parsley-validate=""
								data-parsley-trigger="change"
								noValidate=""
								id={`${type}_form_component`}
								name={type}
							>
								{form}
								{process.env.recaptcha === "true" ?
									<ReCAPTCHA
										ref={reCaptchaRef}
										style={isValidWorkspace === true || type === 'register' ? { display: 'inline-block' } : { display: 'none' }}
										sitekey={process.env.SITE_KEY}
										onChange={recaptchaHandle}
									/>
									: null}
								{submitBtn}
							</form></>}
					{/* {				
				!process.env.enableCreateWorkspace || process.env.enableCreateWorkspace === 'true' || process.env.enableCreateWorkspace === true ? (<div className="mg-t-20 tx-center">
					{type === 'login' ? "Don't have a workspace?" : 'Already have an account?'}
					{type === 'login' ? <Link to="/login/register"> Create a workspace </Link> : <Link to="/login"> Log in </Link>}
				</div>) : null
			} */}
				</>
				}
			</>
	);
};

function mapStateToProps(state) {
	return { authData: state.dataSet.authData };
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ setAuthData }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
